export const PROJECT_NAME = "Halalkoom";
export const storeCategoriesSelect = [
  {
    label: "Tous",
    value: "none",
  },
  {
    label: "Partenaire pro",
    value: "BUSINESS",
  },
  {
    label: "Artisan",
    value: "AT_HOME",
  },
];
// TITLES
const NOTIFICATIONS = "Notifications";
const LOGIN = "Connexion";
const HOME = "Accueil";
const HISTORIC = "Historique des commandes";
const SETTINGS = "Paramètres";
const UPDATE_SETTINGS = "Temps de préparation moyen des plats";
const ADDONS = "Géstion des suppléments";
const REQUESTS = "Géstion des demandes d'approbation du menu";
const PRODUCTS = "Géstion des produits";
const CREATE_REQUEST = "Créer une nouvelle demande";
const UPDATE_REQUEST = "Modification d'une demande";
const UPDATE_MENU = "Modification d'un produit";
const CREATE_ADDON = "Créer un nouveau supplément";
const UPDATE_ADDON = "Modification d'un supplément";
const ADDONS_DETAILS = "Détails du supplément";
const CHANGE_PASSWORD = "Changement de mot de passe";
const PROFILE = "Profil";
const HOLIDAYS = "Fermetures exceptionnelles";
const CREATE_HOLIDAY = "Nouvelle fermeture exceptionnelle";
const UPDATE_HOLIDAY = "Modifier une fermeture exceptionelle";
const TRANSFERS = "Gain quotidien";
const PAYOUTS = "Historique des virements";
const TRANSFER_ERRORS = "Transferts bloqués";
const PAYOUT_DETAIL = "Détails virement";
const TRANSFER_DETAIL = "Détails transaction";
const CODE_PROMOS = "Gestion des codes promos";
const CREATE_PROMOTION = "Créer un code promotionnel";
const UPDATE_PROMOTION = "Modifier un code promotionnel";

//DAY
export const days = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];
export const SEANCE = `firstSeance {
  start
  end
}
secondSeance{
  start
  end
}
thirdSeance{
  start
  end
}`;

export const storeCategories = {
  BUSINESS: "Restaurant",
  AT_HOME: "Artisan",
};

export const cardHeaderTitles = {
  MENUS: "COMMANDES",
};

export const titles = {
  LOGIN,
  HOME,
  SETTINGS,
  UPDATE_SETTINGS,
  ADDONS,
  ADDONS_DETAILS,
  CREATE_ADDON,
  REQUESTS,
  CREATE_REQUEST,
  UPDATE_REQUEST,
  UPDATE_MENU,
  PRODUCTS,
  UPDATE_ADDON,
  NOTIFICATIONS,
  HISTORIC,
  CHANGE_PASSWORD,
  PROFILE,
  HOLIDAYS,
  CREATE_HOLIDAY,
  UPDATE_HOLIDAY,
  TRANSFERS,
  PAYOUTS,
  TRANSFER_ERRORS,
  PAYOUT_DETAIL,
  TRANSFER_DETAIL,
  CODE_PROMOS,
  CREATE_PROMOTION,
  UPDATE_PROMOTION,
};

export const limits = [10, 20, 40, 60, 80, 100];

//REJECTED-ORDER
export const DELIVERED = "DELIVERED";
export const OUTGOING = "OUTGOING";
export const REJECTED_BY_CUSTOMER = "REJECTED_BY_CUSTOMER";
export const REJECTED_BY_DRIVER = "REJECTED_BY_DRIVER";
export const REJECTED_BY_STORE = "REJECTED_BY_STORE";
export const REJECTED_BY_ADMIN = "REJECTED_BY_ADMIN";
export const ACCEPTED_BY_STORE = "ACCEPTED_BY_STORE";
export const REJECTED_BY_SYSTEM = "REJECTED_BY_SYSTEM";
export const SALVAGE = "SALVAGE";
export const SALVAGED = "SALVAGED";
export const rejectedStatus = [
  REJECTED_BY_CUSTOMER,
  REJECTED_BY_DRIVER,
  REJECTED_BY_STORE,
  REJECTED_BY_SYSTEM,
  REJECTED_BY_ADMIN,
];

export const INACTIVE = "INACTIVE";
export const ACTIVE = "ACTIVE";
export const IN_PROGRESS = "IN_PROGRESS";
export const REJECTED = "REJECTED";
export const PASSED = "PASSED";
export const ACCEPTED = "ACCEPTED";
export const requestStatusDetails = {
  IN_PROGRESS: {
    label: "EN COURS",
    className: "text-warning",
  },
  ACCEPTED: {
    label: "ACCEPTÉE",
    className: "text-success",
  },
  REJECTED: {
    label: "REJETÉE",
    className: "text-danger",
  },
};
//ORDER_STATUS

// ALERT

export const ALERT_WARNING = {
  type: "warning",
  icon: "fa fa-exclamation-triangle",
};

export const ALERT_ERROR = {
  type: "error",
  icon: "fa fa-exclamation-circle",
};

export const ALERT_INFO = {
  type: "info",
  icon: "fa fa-info",
};

export const ALERT_SUCCESS = {
  type: "success",
  icon: "fa fa-check",
};

export const ALERT_DEFAULT_CONFIG = {
  manyInstances: false,
  disableAutoClose: false,
  autoClose: 2500,
};

// REGEX
export const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const NAME_REGEX = /^[a-zA-Z]{2,50}$/;
export const REGEX_MOBILE = /*/^(?:\+216)[0-9]{8}$/; */ /^(?:\+33)[0-9]{9,10}$/;

// DATE FORMAT
export const FRENCH_DATE_FORMAT = "DD/MM/YYYY";
export const FRENCH_DATE_TIME_FORMAT = `${FRENCH_DATE_FORMAT} [à] HH:mm`;
export const INPUT_DATE_FORMAT = "YYYY-MM-DD";

export const routeToTitle = {
  "": HOME,
  accueil: HOME,
  demandes: REQUESTS,
  supplements: ADDONS,
  produits: PRODUCTS,
  parametres: SETTINGS,
  "historique-des-commandes": HISTORIC,
  fermetures: HOLIDAYS,
  transactions: TRANSFERS,
  virements: PAYOUTS,
  "transferts-bloqués": TRANSFER_ERRORS,
  "code-promos": CODE_PROMOS,
};
export const categoriesOfProducts = [
  { label: "Categorie 1", value: "Categorie 1" },
  { label: "Categorie 2", value: "Categorie 2" },
  { label: "Categorie 3", value: "Categorie 3" },
];
export const deliveryModes = [
  { label: "Tous", value: "ALL" },
  { label: "Livraison domicile", value: "EXPRESS" },
  { label: "Click&Collect", value: "DRIVE" },
];
export const driversModes = [
  { value: "PLATEFORM", label: "Livreurs Plateform" },
  { value: "OWN_DRIVERS", label: "Mes propres livreurs" },
];
export const codeTypes = {
  AMOUNT: "Montant",
  PERCENT: "Pourcentage",
};
export const commandesOrProducts = [
  { label: "Commande", value: "ORDER" },
  { label: "Produit(s)", value: "PRODUCTS" },
];

export const minimumAmmounts = [
  { label: "Sans montant minimum", value: false },
  { label: "Avec montant minimum", value: true },
];

export const statusOptions = [
  { label: "Actif", value: ACTIVE },
  { label: "Inactif", value: INACTIVE },
];

export const yesNoOptions = [
  { label: "Sans", value: false },
  { label: "Avec", value: true },
];

export const SWITCH_HEIGHT = 20;
export const SWITCH_WIDTH = 45;
export const PREFIX = "HLKM";
export const COMMANDES = "COMMANDES";
export const PERCENT = "PERCENT";
export const PRODUITS = "PRODUITS";

export const SHIPPING_COSTS = 2.9;

export const menuTypeOptions = [
  { label: "Spécialités", value: "MENUS" },
  { label: "Catégories de menu", value: "CATEGORIES" },
  { label: "Sous catégories de menu", value: "SUB_CATEGORIES" },
  { label: "Produits", value: "CATEGORY_TYPE" },
];

export const orderStatusOptions = [
  { label: "En attente", value: IN_PROGRESS },
  { label: "Acceptée", value: ACCEPTED },
  { label: "En cours de livraision", value: OUTGOING },
  { label: "Livrées", value: DELIVERED },
  { label: "Annulées par le Partenaire", value: REJECTED_BY_STORE },
  { label: "Annulé par le Client", value: REJECTED_BY_CUSTOMER },
  // { label: "Annulé par l'administrateur", value: REJECTED_BY_ADMIN }
];

// REGEX
export const REAL_NAME_REGEX = /^[a-zA-Z ]{2,50}$/;
export const MOBILE_REGEX_INCLUSIVE = /^(:?(?:\+|00)33|0)[1-9]{1}[0-9]{8}$/;
export const REGEX_MOBILE_NO_PREFIX = /*/^(?:\+216)[0-9]{8}$/; */ /^[0-9]{9}$/;
export const VAT_REGEX = /^(FR)[0-9]{11}$/;
export const SIRET_REGEX = /^[0-9]{14}$/;
export const SIREN_REGEX = /^[0-9]{9}$/;

export const RIB_REGEX = /^[0-9]{11}$/;
export const userTypes = {
  DRIVER: "DRIVER",
};
export const actorStatusSelect = [
  {
    label: "Tous",
    value: "none",
  },
  {
    label: "Actif",
    value: ACTIVE,
  },
  {
    label: "Inactif",
    value: INACTIVE,
  },
];

export const stripeFilterSelect = [
  {
    label: "Tous",
    value: "none",
  },
  {
    label: "Avec",
    value: "YES",
  },
  {
    label: "Sans",
    value: "NO",
  },
];
export const RATING_FIELDS = `
  total
  partial
  coef
`;
